import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import tPaths from '../../../../../utils/tPaths';

interface IAllItemsToggler {
  styles: Record<string, any>;
  handleToggle: () => void;
}

const AllItemsToggler: React.FC<IAllItemsToggler> = ({ styles, handleToggle }) => {
  const {t} = useTranslation()

  return (
    <Box className={styles.allItemsSelectable} onClick={handleToggle}>
      <Typography variant="subtitle1">{t(tPaths.table.all)}</Typography>
    </Box>
  );
};

export default AllItemsToggler;
